import React from 'react';
import PropTypes from 'prop-types';
import {
  CareItemListWrap,
  CareItemList,
  CareItem,
  CareItemImage,
  CareItemInfo,
} from './DiagnosisResultHomeCareItemListCard.style';
import {
  CardBackground,
  CardContent,
  CardContainer,
  CardBody,
  CardHeader,
  CardCloseButton,
} from '../Common/Common.style';
import Image from '../../../../components/ContentfulImage';
import { CATEGORY_HAIRCARE } from '../CareMenuImage/CareMenuImageConst';

class DiagnosisResultHomeCareItemListCard extends React.Component {
  handleSelectItem = (category, type, slug) => () => {
    this.props.handleSelectItem(category, type, slug);
    this.props.handleCloseCard();
  };

  render() {
    const {
      itemsInfo,
      isOpen,
      handleCloseCard,
      selectedItemSlug,
      recommendedItemSlug,
      selectedCategory,
      selectedType,
      selectedCareMenu,
    } = this.props;
    let items = [];
    if (selectedCareMenu === CATEGORY_HAIRCARE && selectedType === 'Shampoo') {
      itemsInfo.map(item => {
        if (item.subType === 'Hair') {
          items.push(item);
        }
      });
    } else {
      items = itemsInfo;
    }
    return (
      <React.Fragment>
        <CardBackground onClick={handleCloseCard} className={isOpen ? 'active' : ''} />
        <CardContainer className={isOpen ? 'active' : ''}>
          <CardContent>
            <CardHeader onClick={handleCloseCard}>
              <CardCloseButton className="closeButton" />
            </CardHeader>
            <CardBody>
              <CareItemListWrap>
                {!!items &&
                  items.map(item => (
                    <CareItemList className={item.slug === recommendedItemSlug ? 'recommend' : ''} key={item.entryId}>
                      <CareItem
                        className={`care-item  ${item.slug === selectedItemSlug ? 'selected' : ''}`}
                        onClick={this.handleSelectItem(selectedCategory, selectedType, item.slug)}
                      >
                        <CareItemImage className="care-item-image">
                          {item.slug === recommendedItemSlug && <span className="recommend">RECOMMEND</span>}
                          <Image src={item.product.variants[0].image || ''} />
                        </CareItemImage>
                        <CareItemInfo className="care-item-info">
                          {/* <div className="care">{appealShortText || ''}</div> */}
                          <div className="title">{item.product.name || ''}</div>
                          <div className="name">{item.product.range.name || ''}</div>
                        </CareItemInfo>
                      </CareItem>
                    </CareItemList>
                  ))}
              </CareItemListWrap>
            </CardBody>
          </CardContent>
        </CardContainer>
      </React.Fragment>
    );
  }
}

DiagnosisResultHomeCareItemListCard.defaultProps = {
  // eslint-disable-next-line react/forbid-prop-types
  itemsInfo: [],
};

DiagnosisResultHomeCareItemListCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  itemsInfo: PropTypes.array,
  isOpen: PropTypes.bool.isRequired,
  handleCloseCard: PropTypes.func.isRequired,
  handleSelectItem: PropTypes.func.isRequired,
  // eslint-disable-next-line react/require-default-props
  selectedItemSlug: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  recommendedItemSlug: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  selectedCategory: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  selectedType: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  selectedCareMenu: PropTypes.string,
};

export default DiagnosisResultHomeCareItemListCard;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/DiagnosisResultHomeCareItemListCard/DiagnosisResultHomeCareItemListCard.js